export default __webpack_public_path__ + "static/media/outline-visibility-off-24-px.50313fa9.svg";